import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { NAV_LINKS, BRAND } from '../../lib/constants';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 bg-[#7C9CB1] ${
        scrolled
          ? 'shadow-[0_8px_32px_-12px_rgba(124,156,177,0.55)] border-b border-[#F4F8F9]/15'
          : 'border-b border-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between gap-4">
        <Link
          to="/"
          data-testid="brand-logo-link"
          aria-label="Shreesavaa — home"
          className="flex items-center group shrink-0"
          onClick={() => setOpen(false)}
        >
          <img
            src={BRAND.logoUrl}
            alt="Shreesavaa"
            data-testid="brand-logo-image"
            className="h-10 md:h-12 w-auto object-contain transition-opacity duration-300 group-hover:opacity-90"
            style={{
              filter:
                'drop-shadow(0 2px 4px rgba(0,0,0,0.45)) drop-shadow(0 0 16px rgba(0,0,0,0.25))',
            }}
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-5 xl:gap-7">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, '-')}-link`}
              className={({ isActive }) =>
                `text-[11px] xl:text-[12px] tracking-[0.22em] uppercase font-medium whitespace-nowrap transition-colors drop-shadow-[0_1px_3px_rgba(0,0,0,0.35)] ${
                  isActive ? 'text-[#F4F8F9]' : 'text-[#F4F8F9]/80 hover:text-[#F4F8F9]'
                }`
              }
              end={l.path === '/'}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-[#F4F8F9] drop-shadow-[0_1px_3px_rgba(0,0,0,0.35)]"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </div>

      {/* Mobile nav drawer */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-500 bg-[#7C9CB1] ${
          open ? 'max-h-[640px] opacity-100 border-b border-[#F4F8F9]/15' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="px-6 py-8 flex flex-col gap-5">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, '-')}-link`}
              className={({ isActive }) =>
                `font-serif text-2xl drop-shadow-[0_1px_3px_rgba(0,0,0,0.35)] ${
                  isActive ? 'text-[#F4F8F9]' : 'text-[#F4F8F9]/85'
                }`
              }
              end={l.path === '/'}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
